import {JsFormResponseHandlerObject} from '../jsFormTypes';
import {JRpcResponse} from '../jsonRpc/jsonRpcResponseFactory';
import {Localization} from '../../../localization/localization';
import {ErrorToolTip, TooltipDirection} from '../../newErrorToolTip';
import {isValidEmail} from '../validators';
import { disableJsFormHandler } from '../jsForm';
import {GtmSender} from '../../../marketing/GtmSender';
import {SystemEvents} from '../../../constants/gameEvents';
import {StretchPopup} from '../../../popups/stretchPopup';
import { AuthStepConversionSend } from '../../../marketing/auth-step-conversion-send';
import {getErrorMessage, isExpectedRegistrationError} from './getErrorMessage';
import {getUrlToLoginViaToken} from '../../../login/getUrlToLoginViaToken';
import {isLoginAccepted} from '../../../login/loginSuccessMarker';
import {addLoginQueryParams} from '../../../utils/url';
import {Environment} from '../../../environment/environment';
import axios from 'axios';
import {CurrentUser} from '../user/currentUser';
import {OTP_LENGTH, readOtpValue} from '../../../user/otpRegistration';
import {ConsentSources} from '../../../constants/ConsentSources';
import {configureHttpAuth} from '../../../startup/configureHttpAuth';
import {Url} from '../url';
import {getHubApi} from '../accountServiceApi/getAccountServiceApi';
import {FormHandlers} from '../formHandlers';
import {
    EmailOtpRegistrationRequest,
    RequestEmailOtpRegRequest
} from '@scorewarrior/rubens_web_lib/lib/hub-api/protocol/registration-otp-req';

function getFormContainer(caller: HTMLElement|JQuery<HTMLElement>) {
    return $(caller).closest('.js-main');
}

let errorToolTip: ErrorToolTip;

type OtpFormState = {
    allowResend: number,
    isResend: boolean,
    countDown: number
};

function getOtpState($form: JQuery): OtpFormState {
    let formState = $form.data('otpState') as OtpFormState;
    if (!formState) {
        formState = { allowResend: 0, countDown: 0, isResend: false };
        $form.data('otpState', formState);
    }

    return formState;
}

function startCountDown($form: JQuery) {
    const formState = getOtpState($form);
    if (formState.countDown) {
        clearInterval(formState.countDown);
    }
    formState.countDown = window.setInterval(() => {
        updateCounter($form);
    }, 1000);
}

type OtpFormData = JsFormResponseHandlerObject<JRpcResponse<{}>>;

type OtpRegistration = {
    email: string,
    url: string,
    suid: string,
    token: string
};


function updateCounter($form: JQuery) {
    const formState = getOtpState($form);
    const now = new Date().getTime();
    const delta = formState.allowResend ? formState.allowResend - now : 0;
    if (delta < 0) {
        clearInterval(formState.countDown);
        displayReturnText($form);
        return;
    }
    updatePopupText($form, delta);
}

function displayReturnText($form: JQuery) {
    const $info = $('.otp-resend-info', $form);
    $info.html(Localization._n('accounting.OTP_window.resend_code'));
    $('a', $info).off('click')
        .on('click', function(e) {
            e.preventDefault();
            resendOtp($form);
        });
}

async function resendOtp($form: JQuery) {
    const formState = getOtpState($form);
    // The user can go back and ask for another address while this request runs. The reply
    // then belongs to an address the form has left, so it must not touch the counter.
    const email = $form.data('otpEmail');
    $('.pin-input', $form).val('');
    formState.isResend = true;
    formState.allowResend = new Date().getTime() + (window.app.config?.otp?.delay ?? 1000 * 60);
    updateCounter($form);
    const newOtpRequest: RequestEmailOtpRegRequest = {
        email,
        locale: window.app.config.locale,
        current_entry_point: window.app.config.current_entry_point
    };
    try {
        const hubApi = getHubApi();
        await hubApi.requestEmailOtpReg(window.app.deviceIdentifier, newOtpRequest);
        if ($form.data('otpEmail') !== email) {
            return;
        }
        startCountDown($form);
    } catch (exception) {
        reportOtpException(exception);

        if ($form.data('otpEmail') !== email) {
            return;
        }

        formState.allowResend = 0;
        clearInterval(formState.countDown);
        displayReturnText($form);

        ErrorToolTip.getTooltipElement().showTooltipElement(
            $('.otp-resend-info', $form),
            TooltipDirection.RIGHT,
            getOtpExceptionMessage(exception)
        );
    }
}

// The hub client throws on an error response rather than resolving with one.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function reportOtpException(exception: any) {
    if (!isExpectedRegistrationError(exception.code)) {
        console.error(exception);
        window.Sentry.captureException(exception);
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getOtpExceptionMessage(exception: any): string {
    return exception.name === 'RpcReceivedError'
        ? getErrorMessage(exception.code, exception.data)
        : Localization._n('errors.common_error');
}

function getPinTooltipDirection(data: OtpFormData): TooltipDirection {
    return data.form.parents('.forms2').length ? TooltipDirection.RIGHT : TooltipDirection.LEFT;
}

function updatePopupText($form: JQuery, delta:number) {
    const minutes = Math.floor((delta % (1000 * 60 * 60)) / (1000 * 60));
    let seconds:number|string = Math.ceil((delta % (1000 * 60)) / 1000);
    if (seconds < 10) {
        seconds = `0${seconds}`;
    }
    let translationKey = '';
    if (getOtpState($form).isResend) {
        translationKey = 'accounting.OTP_window.code_resend_resend_code_after';
    } else {
        translationKey = 'accounting.OTP_window.resend_code_after';
    }
    $('.otp-resend-info', $form).html(Localization._n(
        translationKey,
        {
            minutes: `${minutes}`,
            seconds: `${seconds}`
        }
    ));
}

// The back controls only swap the step class, so the counter and any digits already typed
// survive the trip to step 1 and back.
function showCodeStep(data: OtpFormData) {
    const formBlock = getFormContainer(data.caller);
    formBlock.removeClass('step1 step2 step3');
    formBlock.addClass('step2');
    data.caller.removeAttr('disabled');
    StretchPopup.stretch();
}

export function initRegistrationWithOtpForm() {
    $(function initRegistrationWithOtpForm() {
        errorToolTip = ErrorToolTip.getTooltipElement();

        $('.js-close-button-reg').on('click', function handleCloseButtonClick() {
            const main = getFormContainer(this);
            main.removeClass('step1 step2 step3');
            main.addClass('step1');
            StretchPopup.stretch();
        });

        $('.js-form .button-back').on('click', function handleBackButtonClick() {
            const main = getFormContainer(this);
            main.removeClass('step1 step2 step3');
            main.addClass('step1');
            StretchPopup.stretch();
        });
    });
    // The OTP form posts to the hub itself. Registering a no-op keeps jsForm off its
    // fallback branch, which would POST the form at the site root first.
    FormHandlers.registerSendRequestHandler('otp_no_request', () => Promise.resolve({}));

    FormHandlers.registerBeforeSendHandler('registrationWithOtpStep1', registrationWithOtpStep1);
    FormHandlers.registerBeforeSendHandler('registrationWithOtpStep2ToSubscription', registrationWithOtpStep2ToSubscription);
    FormHandlers.registerBeforeSendHandler('registrationWithOtpStep2ToPoll', registrationWithOtpStep2ToPoll);

    FormHandlers.registerAfterSendHandler('registrationWithOtpStep2', registrationWithOtpStep2);
    FormHandlers.registerAfterSendHandler('registrationWithOtpStep2Download', registrationWithOtpStep2Download);
    FormHandlers.registerAfterSendHandler('registrationWithOtpStep2Site', registrationWithOtpStep2Site);
    FormHandlers.registerAfterSendHandler('registrationWithOtpStep3WithSubscription', registrationWithOtpStep3WithSubscription);
    FormHandlers.registerAfterSendHandler('registrationWithOtpPollStep3', registrationWithOtpPollStep3);
}

function registrationWithOtpStep1(data: OtpFormData) {
    const $form = data.form;
    const $termsCheckbox = $('.js-terms_agree', $form);
    const email = $('input[name=email]', $form).val() as string;
    const toolTipDirection: keyof typeof TooltipDirection = data.caller.data('tooltipdirection');
    const toolTipDirectionSide: TooltipDirection = TooltipDirection[toolTipDirection];
    const emailInput = $('input[name=email]', data.form);
    const emailInputContainer = emailInput.parents('.white_input');

    $('.error', data.form).removeClass('error');

    if ($termsCheckbox.length && !$termsCheckbox.hasClass('checked')) {
        errorToolTip.showTooltipElement(
            $termsCheckbox,
            toolTipDirectionSide as TooltipDirection,
            Localization._n('agree_error'),
            true
        );

        return false;
    }

    if (!isValidEmail(email)) {
        emailInputContainer.addClass('error');
        errorToolTip.showTooltipElement(
            emailInput,
            toolTipDirectionSide as TooltipDirection,
            Localization._n('wrong_data')
        );
        return false;
    }


    if ($form.data('otpRequesting') || $form.data('otpSubmitting')) {
        return false;
    }
    $form.data('otpRequesting', true);
    getOtpState($form).isResend = false;

    $form.data('otpEmail', email);

    const newOtpRequest: RequestEmailOtpRegRequest = {
        email,
        locale: window.app.config.locale,
        current_entry_point: window.app.config.current_entry_point
    };
    const hubApi = getHubApi();
    hubApi.requestEmailOtpReg(
        window.app.deviceIdentifier,
        newOtpRequest
    ).then(() => {
        $form.data('otpRequesting', false);

        const descriptionText = $('.otp-login-info', data.form);
        descriptionText.html(Localization._n('accounting.OTP_window.description', {value: email}));
        const delay = window.app.config?.otp?.delay ?? 1000 * 60;
        getOtpState($form).allowResend = new Date().getTime() + delay;
        updateCounter($form);
        startCountDown($form);
        $('.pin-input', data.form).val('');
        const authStepConversionSender = new AuthStepConversionSend(window.location);
        authStepConversionSender.send('2');
        $form.data('otpIssuedFor', email);
        showCodeStep(data);
    })
        .catch((exception) => {
            $form.data('otpRequesting', false);
            reportOtpException(exception);
            emailInputContainer.addClass('error');
            errorToolTip.showTooltipElement(
                emailInput,
                toolTipDirectionSide as TooltipDirection,
                getOtpExceptionMessage(exception)
            );

            // The limit blocks every later attempt too, so a code already issued for this
            // address stays reachable rather than trapping the user here.
            if ($form.data('otpIssuedFor') === email) {
                showCodeStep(data);
            }
        });

    return false;
}


/* Runs the tail of a registration at most once at a time. The lock is taken and given back
   here, so no caller can leave it set: a tail that throws cannot deaden the form. It spans
   the tail because finishOtpRegistration, which disables the form, runs inside it. */
async function withOtpRegistration(
    data: OtpFormData,
    tail: (registration: OtpRegistration) => Promise<void>|void
): Promise<void> {
    if (data.form.data('otpSubmitting')) {
        return;
    }
    data.form.data('otpSubmitting', true);

    try {
        const result = await sendOtpRegistration(data);
        if (result) {
            await tail(result);
        } else {
            returnToCodeStep(data);
        }
    } finally {
        data.form.data('otpSubmitting', false);
    }
}

async function sendOtpRegistration(data: OtpFormData): Promise<OtpRegistration|null> {
    const email = data.form.data('otpEmail');
    // An earlier attempt may have created the account and failed only to log in. The code is
    // spent by then, so reuse the tether, and only for the address it was created for.
    const pending = data.form.data('otpTether') as OtpRegistration|undefined;
    if (pending && pending.email === email) {
        return pending;
    }

    // Only a fresh registration needs the code, and a short one would spend an attempt.
    if (isOtpIncomplete(data)) {
        return null;
    }

    const registerRequest: EmailOtpRegistrationRequest = {
        email,
        otp: readOtpValue(data.form),
        locale: window.app.config.locale,
        current_entry_point: window.app.config.current_entry_point
    };
    try {
        const hubApi = getHubApi();
        const response = await hubApi.emailOtpRegistration(
            window.app.deviceIdentifier,
            registerRequest
        );
        window.app.user_huid = response.accountId;
        if (Environment.isLanding()) {
            GtmSender.fireClient(SystemEvents.EMAIL_REG_SUCCESS);
            GtmSender.fireClient(SystemEvents.IS_LANDING_REG);
        }

        const url = getUrlToLoginViaToken(response.tether.token, response.tether.suid);
        const registration = {
            email,
            suid: response.tether.suid,
            token: response.tether.token,
            url: addLoginQueryParams(url)
        };
        data.form.data('otpTether', registration);

        return registration;
    } catch (exception) {
        reportOtpException(exception);

        const input = $('.pin-container', data.form);
        input.addClass('error');
        ErrorToolTip.getTooltipElement().showTooltipElement(
            input,
            getPinTooltipDirection(data),
            getOtpExceptionMessage(exception)
        );
    }

    return null;
}

function finishOtpRegistration(data: OtpFormData) {
    data.form.removeData('otpTether');
    disableJsFormHandler(data.form);
}

async function logInWithToken(url: string, data: OtpFormData): Promise<boolean> {
    try {
        const response = await axios.get(url);

        // Anything but the success script keeps the tether for a retry.
        if (!isLoginAccepted(response?.data)) {
            console.error('login by token refused');
            window.Sentry.captureMessage('login by token refused');

            ErrorToolTip.getTooltipElement().showTooltipElement(
                $('.pin-container', data.form),
                getPinTooltipDirection(data),
                Localization._n('errors.common_error')
            );

            return false;
        }

        return true;
    } catch (exception) {
        // The url carries the tether token, so report the status only. Capturing the
        // exception would put the token into the breadcrumb and the error context.
        const status = exception?.response?.status ?? 'no response';
        console.error(`login by token failed: ${status}`);
        window.Sentry.captureMessage(`login by token failed: ${status}`);

        ErrorToolTip.getTooltipElement().showTooltipElement(
            $('.pin-container', data.form),
            getPinTooltipDirection(data),
            Localization._n('errors.common_error')
        );

        return false;
    }
}

// Reloads after the login, as the password flow did. An iframe would hide a refused login
// and fire the login callbacks, which these forms never did.
async function registrationWithOtpStep2(data: OtpFormData) {
    await withOtpRegistration(data, async(result) => {
        if (!await logInWithToken(result.url, data)) {
            return;
        }

        GtmSender.fireMarketing(SystemEvents.EMAIL_REG_SUCCESS);
        finishOtpRegistration(data);
        configureHttpAuth();
        location.reload();
    });
}

async function registrationWithOtpStep2Download(data: OtpFormData) {
    await withOtpRegistration(data, async(result) => {
        if (!await logInWithToken(result.url, data)) {
            return;
        }

        finishOtpRegistration(data);
        /* The flag-off tails called openDownStep2AndDownload, which also hid the password
           field and re-pointed the step-2 button. Neither exists here, and the form has just
           left jsForm, so the close control is the only part that still applies. */
        $('.js-close-button-reg', getFormContainer(data.caller)).text('');
        window.app.downloadLauncher();
    });
}

async function registrationWithOtpStep2Site(data: OtpFormData) {
    await withOtpRegistration(data, async(result) => {
        if (!await logInWithToken(result.url, data)) {
            return;
        }

        window.app.eventInstall();
        finishOtpRegistration(data);
        configureHttpAuth();
        location.reload();
    });
}

/* A three-step form registers on step 3, where the code fields are hidden. Show them again so
   that the error next to them is visible and the user can correct the code. A two-step form
   is already on the code step, so this only repositions its message. */
function returnToCodeStep(data: OtpFormData) {
    const main = getFormContainer(data.caller);
    main.removeClass('step1 step2 step3');
    main.addClass('step2');
    StretchPopup.stretch();
    // The message was placed against a hidden element, so it needs placing again.
    ErrorToolTip.getTooltipElement().moveTooltipElement();
}

function isOtpIncomplete(data: OtpFormData): boolean {
    $('.error', data.form).removeClass('error');
    if (readOtpValue(data.form).length >= OTP_LENGTH) {
        return false;
    }

    const input = $('.pin-container', data.form);
    input.addClass('error');
    ErrorToolTip.getTooltipElement().showTooltipElement(
        input,
        getPinTooltipDirection(data),
        Localization._n('wrong_data')
    );

    return true;
}

// Three-step forms keep the code on step 2 and register on step 3, so this step only validates.
function advanceToStep3(data: OtpFormData): boolean {
    if (isOtpIncomplete(data)) {
        return false;
    }

    const authStepConversionSender = new AuthStepConversionSend(window.location);
    authStepConversionSender.send('3');

    const main = getFormContainer(data.caller);
    main.removeClass('step1 step2 step3');
    main.addClass('step3');
    data.caller.removeAttr('disabled');
    StretchPopup.stretch();

    return true;
}

function registrationWithOtpStep2ToSubscription(data: OtpFormData) {
    if (advanceToStep3(data)) {
        $("span[data-action='openSingle']").parent()
            .hide();
    }

    return false;
}

function registrationWithOtpStep2ToPoll(data: OtpFormData) {
    advanceToStep3(data);

    return false;
}

async function registrationWithOtpStep3WithSubscription(data: OtpFormData) {
    await withOtpRegistration(data, async(result) => {
        window.app.config.suid = result.suid;
        window.app.config.user_auth_token = result.token;

        // Both effects below belong to the registration, so they follow the login and a
        // retry of the login alone does not repeat them.
        if (!await logInWithToken(result.url, data)) {
            return;
        }

        GtmSender.fireMarketing(SystemEvents.EMAIL_REG_SUCCESS);

        if (data.caller.data('subscription') !== false) {
            const email = data.form.data('otpEmail');
            const currentUser = CurrentUser.getInstance();
            try {
                const isChanged = await currentUser.setConsentState(email, true, ConsentSources.LP);
                if (!isChanged) {
                    console.error(`Can't set consent for user with suid ${currentUser.getSuid()}`);
                }
            } catch (exception) {
                // The consent is optional. The account exists, so let the user in regardless.
                reportOtpException(exception);
            }
        }

        finishOtpRegistration(data);
        configureHttpAuth();
        location.reload();
    });
}

async function registrationWithOtpPollStep3(data: OtpFormData) {
    await withOtpRegistration(data, async(result) => {
        const userSourceAd = $('.step3 .js-subscription_agree.checked').attr('id');
        const url = Url.current();
        url.addQueryParam('poll', userSourceAd ? userSourceAd : 'NULL');

        if (!await logInWithToken(result.url, data)) {
            return;
        }

        GtmSender.fireMarketing(SystemEvents.EMAIL_REG_SUCCESS);
        finishOtpRegistration(data);
        configureHttpAuth();
        url.setHref();
    });
}


